import React from 'react';

// Marque de l'application : « FI. » sur pastille orange — même dessin que
// l'icône PWA (public/icon-master.html) : lettres blanches + point or,
// la signature de la famille de produits A97 (BI. cobalt, FI. orange…).
export default function LogoFI({ size = 36, radius = 11 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" role="img" aria-label="A97 Finance" focusable="false">
      <rect width="48" height="48" rx={radius} fill="#E4571B" />
      <text
        x="21" y="25.5"
        textAnchor="middle" dominantBaseline="central"
        fontFamily="'Segoe UI', system-ui, -apple-system, Helvetica, Arial, sans-serif"
        fontSize="20" fontWeight="800" letterSpacing="0.5" fill="#fff"
      >
        FI
      </text>
      <rect x="33.5" y="27.5" width="5.5" height="5.5" rx="1.6" fill="#C9A84C" />
    </svg>
  );
}
